import {useEffect, useState} from "react";
import {DashboardComponentPropsBase, DashboardComponentState} from "../../components/pages/dashboard/components/interfaces";

export const useComponentStateCallback = <T extends any>(
    componentProps: DashboardComponentPropsBase<T>,
    initialState?: "loading" | "finished"
) => {
    const [state, setState] = useState<Partial<DashboardComponentState>>({state: initialState ?? "loading", id: componentProps.id});

    useEffect(() => {
        if (componentProps.stateCb) {
            componentProps.stateCb({...state, id: componentProps.id} as DashboardComponentState);
        }
    }, [state]);

    return setState;
}